import React from 'react';
import { useRecoilValue } from 'recoil';

import StandardModal from '@/components/commons/StandardModal';
import { userAtom } from '@/components/with_auth/State';

import BioBrief from './BioBrief';

interface Props {
    readonly closeModal: () => void,
    readonly display: { open: boolean, briefIndex: any },
    readonly handleModal?: any;
}

function BioBriefModal({
    closeModal,
    display,
    handleModal = () => { },
}: Props) {
    const user = useRecoilValue(userAtom);

    const brief = user.briefs.find((item) => item.id === display.briefIndex);

    return (
        <StandardModal
            open={display.open}
            onClose={closeModal}
            data-testid="modal-bio"
            headline=""
            classNames={{
                modal: 'flex p-0 max-w-[1200px] max-h-[600px] lg:max-h-[800px] focus:outline-none focus-visible:outline-none focus-visible:ring-0',
            }}
            styles={{
                modalContainer: {
                    display: 'flex',
                    maxWidth: '100%',
                    justifyContent: 'center',
                    alignContent: 'center',
                    alignItems: 'center',
                },
            }}
        >
            <div className="flex flex-col justify-center items-center">
                <BioBrief
                    brief={brief}
                    user={user}
                    openModal={handleModal}
                />
            </div>
        </StandardModal>
    );
}

export default BioBriefModal;
